<script setup lang="ts">
import { onMounted } from "vue";
import { useNotificationStore } from "@/stores/notification-store";
import { storeToRefs } from "pinia";
import NotificationItem from "./NotificationItem.vue";

const notificationStore = useNotificationStore();
const { notifications, loading, unreadCount } = storeToRefs(notificationStore);

onMounted(async () => {
  await notificationStore.fetchNotifications();
});

const handleMarkAsRead = async (id: string) => {
  await notificationStore.markAsRead(id);
};

const handleDelete = async (id: string) => {
  await notificationStore.deleteNotification(id);
};

const handleMarkAllAsRead = async () => {
  await notificationStore.markAllAsRead();
};
</script>

<template>
  <div class="notification-list">
    <div class="card-header p-2">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="text-body-emphasis mb-0">Notifications</h2>
        <button
          v-if="unreadCount > 0"
          class="bb-btn-secondary-cta btn-sm"
          type="button"
          @click="handleMarkAllAsRead"
        >
          Mark all as read
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else-if="notifications.length === 0" class="text-center py-4">
        <i class="bi bi-bell-slash fs-1 text-muted mb-3"></i>
        <p class="text-muted mb-0">No notifications</p>
      </div>
      <div
        v-else
        class="notification-scroll-container"
      >
        <NotificationItem
          v-for="notification in notifications"
          :key="notification.id"
          :notification="notification"
          @mark-as-read="handleMarkAsRead"
          @delete="handleDelete"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.notification-scroll-container {
  max-height: 27rem;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
